function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader?minimize!../../vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-61ade637\",\"scoped\":false,\"hasInlineConfig\":false}!../../vue-loader/lib/selector?type=styles&index=0!./VueDatepickerLocal.vue")
}
var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./VueDatepickerLocal.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-61ade637\",\"hasScoped\":false}!../../vue-loader/lib/selector?type=template&index=0!./VueDatepickerLocal.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-datepicker-local/src/VueDatepickerLocal.vue
// module id = 722
// module chunks = 7